/* Copyright (c) 2018 Scaper */

import { combineReducers, createStore } from "redoodle";
import { IAppState } from "./appState";
import { placeReducer } from "./placeReducer";
import { userReducer } from "./userReducer";

export function createAppStore() {
    const reducer = combineReducers<IAppState>({
        place: placeReducer,
        user: userReducer,
    });

    return createStore<IAppState>(reducer, {
        place: {
            places: {},
        },
        user: {
            phoneNumberDocument: undefined,
            userInfo: undefined,
        },
    });
}
